<template>
  <i class="bi bi-check-lg text-success" v-if="player.team_id"></i>
</template>
<script setup>
import { defineProps, ref, onMounted } from "vue";
import supabase from "@/supabase/config";
const props = defineProps(["player_id"]);
const player = ref({ team_id: null });
onMounted(() => {
  fetchPlayer();
});
const fetchPlayer = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("id", props.player_id);
  player.value = players[0];
};
</script>
